import { get } from 'lodash';

export const getCounter = (state, entityId) => state.counters[entityId];

export const getEntityLikeCount = (state, entity) =>
  get(state.counters[entity._id], 'likeCount', get(entity, 'likeCount'));
